/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ModuleDropdown = zod.strictObject({
    label: zod.string(),
    value: zod
        .enum([
            'DATA_COLLECTION_FORMS',
            'DEFAULT',
            'DHIS2_MAPPING',
            'EMBEDDED_LINKS',
            'ENTITIES',
            'EXTERNAL_STORAGE',
            'PLANNING',
            'POLIO_PROJECT',
            'REGISTRY',
            'PAYMENTS',
            'COMPLETENESS_PER_PERIOD',
            'TRYPELIM_PROJECT',
            'DATA_VALIDATION',
            'SAAS',
            'STOCK_MANAGEMENT',
            'SNT_MALARIA',
            'FORM_AI',
            'VALIDATION_WORKFLOW',
        ])
        .describe(
            '\* `DATA_COLLECTION_FORMS` - DATA_COLLECTION_FORMS\n\* `DEFAULT` - DEFAULT\n\* `DHIS2_MAPPING` - DHIS2_MAPPING\n\* `EMBEDDED_LINKS` - EMBEDDED_LINKS\n\* `ENTITIES` - ENTITIES\n\* `EXTERNAL_STORAGE` - EXTERNAL_STORAGE\n\* `PLANNING` - PLANNING\n\* `POLIO_PROJECT` - POLIO_PROJECT\n\* `REGISTRY` - REGISTRY\n\* `PAYMENTS` - PAYMENTS\n\* `COMPLETENESS_PER_PERIOD` - COMPLETENESS_PER_PERIOD\n\* `TRYPELIM_PROJECT` - TRYPELIM_PROJECT\n\* `DATA_VALIDATION` - DATA_VALIDATION\n\* `SAAS` - SAAS\n\* `STOCK_MANAGEMENT` - STOCK_MANAGEMENT\n\* `SNT_MALARIA` - SNT_MALARIA\n\* `FORM_AI` - FORM_AI\n\* `VALIDATION_WORKFLOW` - VALIDATION_WORKFLOW',
        ),
});

export type ModuleDropdown = zod.input<typeof ModuleDropdown>;
export type ModuleDropdownOutput = zod.output<typeof ModuleDropdown>;
